import React from 'react';

export const alignedBox = (title, content) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
    }}
  >
    <h3>{title}</h3>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        alignContent: 'center',
      }}
    >
      {content}
    </div>
  </div>
);